import { instanceBase as axios } from '../lib/axios';

export const RESUME_LOGIN_START = 'RESUME_LOGIN_START';
export const RESUME_LOGIN_SUCCESS = 'RESUME_LOGIN_SUCCESS';
export const RESUME_LOGIN_ERROR = 'RESUME_LOGIN_ERROR';
export const SET_USER_ANONYMOUS = 'SET_USER_ANONYMOUS';

export function resumeLogin(isLtiLaunchFromLaze) {
    return async (dispatch) => {
        dispatch({ type: RESUME_LOGIN_START });
        try {
            const { data, status } = await axios.get(isLtiLaunchFromLaze ? '/api/lti/user' : '/api/users/user');
            const body = {
                type: RESUME_LOGIN_SUCCESS,
                payload: { data, status },
            };
            dispatch(body);
            return body;
        } catch (err) {
            const body = { type: RESUME_LOGIN_ERROR, payload: { status: err?.response?.status } };
            dispatch(body);
            return body;
        }
    };
}

export function setLazeUser(lazeUser) {
    return {
        type: RESUME_LOGIN_SUCCESS,
        payload: {
            data: {
                firstName: lazeUser,
                lastName: '',
            },
            status: 200,
        },
    };
}
